import * as types from "../actions/types/app.types";

const initialState = {
    isDark: false,
    showMobile: false,
    isMasked: JSON.parse(localStorage.getItem("hideBalance")),
    isCollapsed: localStorage.getItem("isCollapsed") === "true",
    hideSideNav: false,
};

export const appThemeReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.TOGGLE_THEME:
            return {
                ...state,
                // isLight: !state.isLight,
                isDark: action.payload,
            };
        case types.TOGGLE_SHOW_MOBILE:
            return {
                ...state,
                showMobile: action.payload,
            };
        case types.TOGGLE_MASK_BALANCE:
            return {
                ...state,
                isMasked: action.payload,
            };
        case types.TOGGLE_SIDE_NAV:
            return {
                ...state,
                isCollapsed: action.payload,
            };
        case types.HIDE_SIDE_NAV:
            return {
                ...state,
                hideSideNav: action.payload,
            };
        default:
            return state;
    }
};
